import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react";
import {
  FormLayout,
  Text,
  TextField,
  Select,
  InlineError,
  Collapsible,
  Stack,
  Button,
  Checkbox,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { validate } from "email-validator";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const EditUser = forwardRef((props, ref) => {
  const [firstNameValue, setFirstNameValue] = useState("");
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, firstName: newValue });
    setFirstNameError("");
  };
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const handleChangeLastName = (newValue) => {
    setItem({ ...item, lastName: newValue });
    setLastNameError("");
  };
  const [lastNameError, setLastNameError] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
    setEmailError("");
  };
  const [emailError, setEmailError] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const handleChangePassword = useCallback((newValue) => {
    setPasswordValue(newValue);
    setPasswordError("");
    setPasswordsError("");
  }, []);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const handleChangeConfirmPassword = useCallback((newValue) => {
    setConfirmPasswordValue(newValue);
    setConfirmPasswordError("");
    setPasswordsError("");
  }, []);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordsError, setPasswordsError] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const handleSelectChangeRole = (newValue) => {
    setItem({ ...item, role: newValue });
    setRoleError("");
  };
  const optionsRoles = [
    // { label: "Author", value: "3" },
    // { label: "Administrator", value: "2" },
    { label: "Super Admin", value: "1" },
    { label: "Custom", value: "0" },
  ];
  const [roleError, setRoleError] = useState("");
  const [item, setItem] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    dashboard: true,
    pagesView: true,
    pagesAdd: true,
    pagesEdit: true,
    pagesDelete: true,
    sectionsView: true,
    sectionsAdd: true,
    sectionsEdit: true,
    sectionsDelete: true,
    blogsView: true,
    blogsAdd: true,
    blogsEdit: true,
    blogsDelete: true,
    sectionsView: true,
    sectionsAdd: true,
    sectionsEdit: true,
    sectionsDelete: true,
    versionClone: true,
    versionPublish: true,
    uiText: true,
    navigation: true,
    crm: true,
    settings: true,
  });
  const handleChangeDashboard = (newValue) => {
    setItem({ ...item, dashboard: newValue });
  };
  const handleChangePagesView = (newValue) => {
    setItem({ ...item, pagesView: newValue });
  };
  const handleChangePagesAdd = (newValue) => {
    setItem({ ...item, pagesAdd: newValue });
  };
  const handleChangePagesEdit = (newValue) => {
    setItem({ ...item, pagesEdit: newValue });
  };
  const handleChangePagesDelete = (newValue) => {
    setItem({ ...item, pagesDelete: newValue });
  };

  const handleChangeSectionsView = (newValue) => {
    setItem({ ...item, sectionsView: newValue });
  };
  const handleChangeSectionsAdd = (newValue) => {
    setItem({ ...item, sectionsAdd: newValue });
  };
  const handleChangeSectionsEdit = (newValue) => {
    setItem({ ...item, sectionsEdit: newValue });
  };
  const handleChangeSectionsDelete = (newValue) => {
    setItem({ ...item, sectionsDelete: newValue });
  };

  const handleChangeBlogsView = (newValue) => {
    setItem({ ...item, blogsView: newValue });
  };
  const handleChangeBlogsAdd = (newValue) => {
    setItem({ ...item, blogsAdd: newValue });
  };
  const handleChangeBlogsEdit = (newValue) => {
    setItem({ ...item, blogsEdit: newValue });
  };
  const handleChangeBlogsDelete = (newValue) => {
    setItem({ ...item, blogsDelete: newValue });
  };
  const handleChangeVersionClone = (newValue) => {
    setItem({ ...item, versionClone: newValue });
  };
  const handleChangeVersionPublish = (newValue) => {
    setItem({ ...item, versionPublish: newValue });
  };
  const handleChangeUiText = (newValue) => {
    setItem({ ...item, uiText: newValue });
  };
  const handleChangeNavigation = (newValue) => {
    setItem({ ...item, navigation: newValue });
  };
  const handleChangeCrm = (newValue) => {
    setItem({ ...item, crm: newValue });
  };
  const handleChangeSettings = (newValue) => {
    setItem({ ...item, settings: newValue });
  };
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  useImperativeHandle(ref, () => ({
    handleSave() {
      if (
        !item.email ||
        !validate(item.email.replace(/\s/g, "")) ||
        !item.firstName ||
        !item.lastName ||
        passwordValue !== confirmPasswordValue ||
        (passwordValue.length < 6 && confirmPasswordValue) ||
        item.role === ""
      ) {
        !validate(item.email.replace(/\s/g, "")) &&
          setEmailError("Please use a valid email address");
        !item.firstName && setFirstNameError("This field is required");
        !item.lastName && setLastNameError("This field is required");
        !item.email && setEmailError("This field is required");
        !passwordValue && setPasswordError("This field is required");
        item.role === "" && setRoleError("Please select a role");
        !confirmPasswordValue &&
          setConfirmPasswordError("This field is required");
        passwordValue !== confirmPasswordValue &&
          setPasswordsError("Passwords do not match");
        passwordValue.length < 6 &&
          confirmPasswordValue &&
          setPasswordsError("Passwords must be at least 6 characters");
      } else {
        props.handleSavingState();
        let permissionsArray = [];
        item.dashboard && permissionsArray.push("dashboard");
        item.pagesView && permissionsArray.push("view pages");
        item.pagesAdd && permissionsArray.push("create pages");
        item.pagesEdit && permissionsArray.push("edit pages");
        item.pagesDelete && permissionsArray.push("delete pages");
        item.blogsView && permissionsArray.push("view blogs");
        item.blogsAdd && permissionsArray.push("create blogs");
        item.blogsEdit && permissionsArray.push("edit blogs");
        item.blogsDelete && permissionsArray.push("delete blogs");
        item.sectionsView && permissionsArray.push("view sections");
        item.sectionsAdd && permissionsArray.push("create sections");
        item.sectionsEdit && permissionsArray.push("edit sections");
        item.sectionsDelete && permissionsArray.push("delete sections");
        item.versionClone && permissionsArray.push("clone versions");
        item.versionPublish && permissionsArray.push("publish versions");
        item.uiText && permissionsArray.push("ui text");
        item.navigation && permissionsArray.push("navigations");
        item.crm && permissionsArray.push("crm");
        item.settings && permissionsArray.push("settings");

        const bodyObj = {
          ...(item.firstName && { first_name: item.firstName }),
          ...(item.lastName && { last_name: item.lastName }),
          ...(item.email && { email: item.email.replace(/\s/g, "") }),
          ...(passwordValue && { password: passwordValue }),
          ...(confirmPasswordValue && {
            "confirm-password": confirmPasswordValue,
          }),
          ...(item.role !== "" && {
            role: item.role !== "0" ? item.role : "",
          }),
          is_active: 1,
          ...(item.role === "0" && { permissions: permissionsArray }),
        };

        axios
          .patch(`management/users/${props.id}`, bodyObj)
          .then((res) => {
            props.handleChangeModalAndRefresh();
          })
          .catch((error) => {
            // Error
            if (error.response) {
              props.handleResetSaving();
              setPasswordError(
                <ul>
                  {error.response.data.errors.password.map((element, index) => {
                    return (
                      <div key={index}>
                        <h2>{element}</h2>
                      </div>
                    );
                  })}
                </ul>
              );
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    },
  }));

  useEffect(() => {
    axios
      .get(`management/users/${props.id}`)
      .then((result) => {
        setItem({
          firstName: result?.data?.data?.first_name
            ? result?.data?.data?.first_name
            : "",
          lastName: result?.data?.data?.last_name
            ? result?.data?.data?.last_name
            : "",
          email: result?.data?.data?.email ? result?.data?.data?.email : "",
          role: result?.data?.data?.roles[0]
            ? String(result?.data?.data?.roles[0].id)
            : "0",
          dashboard:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "dashboard"
            ).length !== 0,
          pagesView:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "view pages"
            ).length !== 0,
          pagesAdd:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "create pages"
            ).length !== 0,
          pagesEdit:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "edit pages"
            ).length !== 0,
          pagesDelete:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "delete pages"
            ).length !== 0,
          blogsView:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "view blogs"
            ).length !== 0,
          blogsAdd:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "create blogs"
            ).length !== 0,
          blogsEdit:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "edit blogs"
            ).length !== 0,
          blogsDelete:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "delete blogs"
            ).length !== 0,
          sectionsView:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "view sections"
            ).length !== 0,
          sectionsAdd:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "create sections"
            ).length !== 0,
          sectionsEdit:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "edit sections"
            ).length !== 0,
          sectionsDelete:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "delete sections"
            ).length !== 0,
          versionClone:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "clone versions"
            ).length !== 0,
          versionPublish:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "publish versions"
            ).length !== 0,
          uiText:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "ui text"
            ).length !== 0,
          navigation:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "navigations"
            ).length !== 0,
          crm:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(({ name }) => name === "crm")
              .length !== 0,
          settings:
            result?.data?.data?.permissions &&
            result?.data?.data?.permissions?.length &&
            result?.data?.data?.permissions.filter(
              ({ name }) => name === "settings"
            ).length !== 0,
        });
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <FormLayout>
      <FormLayout.Group>
        <FormLayout>
          <TextField
            value={item.firstName}
            onChange={handleChangeFirstName}
            error={firstNameError}
            label="First Name"
          />
        </FormLayout>
        <FormLayout>
          <TextField
            value={item.lastName}
            onChange={handleChangeLastName}
            error={lastNameError}
            label=" Last Name"
          />
        </FormLayout>
      </FormLayout.Group>

      <TextField
        value={item.email}
        onChange={handleChangeEmail}
        error={emailError}
        label="Email"
      />

      <Select
        placeholder="Please select"
        options={optionsRoles}
        onChange={handleSelectChangeRole}
        value={item.role}
        error={roleError}
        label="Role"
      />
      {item.role === "0" && (
        <div style={{ marginTop: "3rem" }}>
          <FormLayout>
            <Text variant="headingXs" as="h6">
              DASHBOARD
            </Text>

            <Checkbox
              label="Dashboard"
              checked={item.dashboard}
              onChange={handleChangeDashboard}
            />
            <Text variant="headingXs" as="h6">
              PAGES
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.pagesView}
                onChange={handleChangePagesView}
              />
              <Checkbox
                label="Add"
                checked={item.pagesAdd}
                onChange={handleChangePagesAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.pagesEdit}
                onChange={handleChangePagesEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.pagesDelete}
                onChange={handleChangePagesDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              SECTIONS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.sectionsView}
                onChange={handleChangeSectionsView}
              />
              <Checkbox
                label="Add"
                checked={item.sectionsAdd}
                onChange={handleChangeSectionsAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.sectionsEdit}
                onChange={handleChangeSectionsEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.sectionsDelete}
                onChange={handleChangeSectionsDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              BLOGS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.blogsView}
                onChange={handleChangeBlogsView}
              />
              <Checkbox
                label="Add"
                checked={item.blogsAdd}
                onChange={handleChangeBlogsAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.blogsEdit}
                onChange={handleChangeBlogsEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.blogsDelete}
                onChange={handleChangeBlogsDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              VERSIONS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="Clone"
                checked={item.versionClone}
                onChange={handleChangeVersionClone}
              />
              <Checkbox
                label="Publish"
                checked={item.versionPublish}
                onChange={handleChangeVersionPublish}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              UI TEXT
            </Text>
            <Checkbox
              label="UI Text"
              checked={item.uiText}
              onChange={handleChangeUiText}
            />
            <Text variant="headingXs" as="h6">
              CRM
            </Text>
            <Checkbox
              label="CRM"
              checked={item.crm}
              onChange={handleChangeCrm}
            />
            <Text variant="headingXs" as="h6">
              NAVIGATION
            </Text>
            <Checkbox
              label="Navigation"
              checked={item.navigation}
              onChange={handleChangeNavigation}
            />
            <Text variant="headingXs" as="h6">
              SETTINGS
            </Text>
            <Checkbox
              label="Settings"
              checked={item.settings}
              onChange={handleChangeSettings}
            />
          </FormLayout>
        </div>
      )}
      <Stack vertical>
        <Button
          onClick={handleToggle}
          ariaExpanded={open}
          ariaControls="basic-collapsible"
          primary
        >
          Change Password
        </Button>
        <Collapsible
          open={open}
          id="basic-collapsible"
          transition={{ duration: "300ms", timingFunction: "ease-in-out" }}
          expandOnPrint
        >
          <FormLayout.Group>
            <FormLayout>
              <TextField
                label="New Password"
                value={passwordValue}
                onChange={handleChangePassword}
                error={passwordError}
              />
            </FormLayout>
            <FormLayout>
              <TextField
                label="Confirm New Password"
                value={confirmPasswordValue}
                onChange={handleChangeConfirmPassword}
                error={confirmPasswordError}
              />
            </FormLayout>
          </FormLayout.Group>
          <InlineError message={passwordsError} />
        </Collapsible>
      </Stack>
    </FormLayout>
  );
});

export default EditUser;
